import { useRecordContext } from "ra-core";
import { RecordField } from "@/components/admin/record-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { Show } from "@/components/admin/show";
import { Card, CardContent } from "@/components/ui/card";

import { StatusBadge } from "../faromarket-shared/StatusBadge";

const DirectionField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.direction} kind="direction" />;
};

export const InteractionShow = () => (
  <Show>
    <Card>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <RecordField source="type" label="resources.interactions.fields.type" />
        <RecordField
          source="direction"
          label="resources.interactions.fields.direction"
        >
          <DirectionField />
        </RecordField>
        <RecordField
          source="channel"
          label="resources.interactions.fields.channel"
        />
        <RecordField
          source="occurred_at"
          label="resources.interactions.fields.occurred_at"
        />
        <RecordField
          source="title"
          label="resources.interactions.fields.title"
          className="md:col-span-2"
        />
        <RecordField
          source="content"
          label="resources.interactions.fields.content"
          className="md:col-span-2"
        />
        <RecordField
          source="company_id"
          label="resources.interactions.fields.company_id"
        >
          <ReferenceField
            source="company_id"
            reference="companies"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="contact_id"
          label="resources.interactions.fields.contact_id"
        >
          <ReferenceField
            source="contact_id"
            reference="contacts"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="lead_id"
          label="resources.interactions.fields.lead_id"
        >
          <ReferenceField
            source="lead_id"
            reference="leads"
            link="show"
            empty="—"
          />
        </RecordField>
        <RecordField
          source="deal_id"
          label="resources.interactions.fields.deal_id"
        >
          <ReferenceField
            source="deal_id"
            reference="deals"
            link={false}
            empty="—"
          />
        </RecordField>
        <RecordField
          source="task_id"
          label="resources.interactions.fields.task_id"
        >
          <ReferenceField
            source="task_id"
            reference="tasks"
            link={false}
            empty="—"
          />
        </RecordField>
        <RecordField
          source="source"
          label="resources.interactions.fields.source"
        />
      </CardContent>
    </Card>
  </Show>
);
